import React, { useState, useEffect } from 'react';
import DashboardSidebar from '../../components/DashboardSidebar';
import Nav from '../../components/Nav';
import ApiService from '../../services/ApiService';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const EditOrders = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [orderData, setOrderData] = useState({
        amount: '',
        currency: '',
        status: '',
        expiring_at: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    const fetchOrder = async () => {
        if (!id) return;
        setIsLoading(true);
        try {
            const response = await ApiService.get(`/cms/orders/${id}`);
            setOrderData(response?.data);
        } catch (error) {
            console.error("Error fetching order:", error);
            toast.error("Failed to fetch order details.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (field, value) => {
        setOrderData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setIsLoading(true);
        try {
            const payload = {
                data: {
                    ...orderData,
                    amount: orderData?.amount,
                    currency: orderData?.currency,
                    status: orderData?.status,
                    expiring_at: orderData?.expiring_at,
                }
            };

            if (id) {
                await ApiService.put(`/cms/orders/${id}`, payload);
                toast.success("Order updated successfully!");
            } else {
                toast.error("Order ID is missing.");
            }

            navigate('/dashboard/orders/list');
        } catch (error) {
            console.error("Error saving order:", error);
            toast.error("Failed to save order.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchOrder();
        }
    }, [id]);

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page">
                <div className="tyn-main tyn-content-inner" id="tynMain">
                    <div className="container">
                        <div className={`${id ? "edit-dashboard-nav" : "tyn-profile"} d-flex align-items-center justify-content-between px-5 py-4`} style={{ background: "white", borderRadius: "1rem" }}>
                            <div>
                                <h3 className="text-capitalize center">Edit Order</h3>
                            </div>
                            <div className="buttons d-flex">
                                <button
                                    className="btn btn-primary me-2"
                                    aria-label="Save changes"
                                    onClick={handleSave}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Saving..." : "Save Changes"}
                                </button>
                                <Link className="btn btn-light" to="/dashboard/orders/list" aria-label="Cancel and back">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-arrow-left"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            stroke="currentColor"
                                            strokeWidth="0.3"
                                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                                        />
                                    </svg>
                                    Back to List
                                </Link>
                            </div>
                            <div className="back-btn-mobile" style={{ display: 'none' }}>
                                <Link className="btn btn-light" to="/dashboard/orders/list" aria-label="Back to list">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" stroke="currentColor" strokeWidth="0.3" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        <div className="tyn-profile">
                            <div className="tyn-profile-details mt-4">
                                <div className="tab-content">
                                    <div className="tab-pane show active" id="order-edit" tabIndex="0">
                                        <div className="row gy-5">
                                            <div className="col-12">
                                                <div className="row gy-4">
                                                    <div className="col-lg-3">
                                                        <h6>Order Details</h6>
                                                        <div className="tyn-subtext">
                                                            Edit the order details
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-9">
                                                        <div className="row g-gs">
                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="amount">
                                                                        Amount
                                                                    </label>
                                                                    <div className="form-control-wrap">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="amount"
                                                                            placeholder="Order Amount"
                                                                            value={orderData?.amount}
                                                                            onChange={(e) =>
                                                                                handleInputChange("amount", e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="currency">
                                                                        Currency
                                                                    </label>
                                                                    <div className="form-control-wrap">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="currency"
                                                                            placeholder="Currency (e.g., USD)"
                                                                            value={orderData?.currency}
                                                                            onChange={(e) =>
                                                                                handleInputChange("currency", e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="status">
                                                                        Status
                                                                    </label>
                                                                    <div className="form-control-wrap">
                                                                        <select
                                                                            id="status"
                                                                            className="form-control"
                                                                            value={orderData?.status}
                                                                            onChange={(e) => handleInputChange("status", e.target.value)}>
                                                                            <option value="succeeded">Succeeded</option>
                                                                            <option value="failed">Failed</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="expiring_at">
                                                                        Expiry Date
                                                                    </label>
                                                                    <div className="form-control-wrap">
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            id="expiring_at"
                                                                            value={orderData?.expiring_at}
                                                                            onChange={(e) =>
                                                                                handleInputChange("expiring_at", e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-12">
                                                                <div className="d-flex justify-content-end buttons mt-5">
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        onClick={handleSave}
                                                                        disabled={isLoading}
                                                                    >
                                                                        {isLoading ? "Saving..." : "Save Changes"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditOrders;
